import {
  // Zap as ZapIcon,
  User as UserIcon,
  HelpCircle as HelpIcon,
  Activity as ActivityIcon,
  // DollarSign as DollarIcon,
  ShoppingCart as CartIcon,
  Settings as SettingsIcon,
  BookOpen as BookIcon,
} from 'react-feather';

const navConfig = [
  /*
  {
    items: [
      {
        title: 'Dashboard',
        href: '/app/reports/dashboard',
        icon: Columns,
      },
    ],
  },
  */
  {
    items: [
      {
        title: 'Mi información personal',
        href: '/app/miinformacionpersonal',
        icon: UserIcon,
        permission: [
          'app:general:miinformacionpersonal:miinformacionpersonal:view',
        ],
      },
    ],
  },
  // {
  //   items: [
  //     {
  //       title: 'Mi perfil',
  //       href: '/app/perfil',
  //       icon: ZapIcon,
  //       permission: [
  //         'app:perfil:general',
  //       ],
  //     },
  //   ],
  // },
  {
    items: [
      {
        title: 'Mis compras',
        href: '/app/miscompras',
        icon: CartIcon,
        permission: [
          'app:general:miscompras:miscompras:view',
        ],
      },
    ],
  },
  // {
  //   items: [
  //     {
  //       title: 'Bonos - Referidos',
  //       href: '/app/bonosreferidos',
  //       icon: DollarIcon,
  //       permission: [
  //         'app:general:bonos',
  //       ],
  //       items: [
  //         {
  //           title: 'Mis bonos',
  //           href: '/app/bonos',
  //           permission: [
  //             'app:general:bonos',
  //           ],
  //         },
  //         {
  //           title: 'Referidos',
  //           href: '/app/bonosreferidos/referidos',
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    items: [
      {
        title: 'Consultas',
        href: '/app/consultas',
        icon: BookIcon,
        permission: [
          'app:general:consultas:usuariosregistrados:view',
          'app:general:consultas:historicocambioestados:view',
        ],
        items: [
          {
            title: 'Usuarios registrados',
            href: '/app/consultas/usuariosregistrados',
            permission: [
              'app:general:consultas:usuariosregistrados:view',
            ],
          },
          // {
          //   title: 'Suscripciones',
          //   href: '/app/consultas/suscripciones',
          //   permission: [
          //     'app:consultas:usuariosregistrados',
          //   ],
          // },
          {
            title: 'Histórico cambio de estados',
            href: '/app/consultas/historicocambiodeestados',
            permission: [
              'app:general:consultas:historicocambioestados:view',
            ],
          },
        ],
      },
      {
        title: 'Administración',
        href: '/app/administracion',
        icon: ActivityIcon,
        permission: [
          'app:general:administracion:compras:view',
          'app:general:administracion:compraproducto:view',
          'app:general:administracion:controlinformacionpersonal:view',
        ],
        items: [
          {
            title: 'Compras',
            href: '/app/administracion/compras',
            permission: [
              'app:general:administracion:compras:view',
            ],
          },
          {
            title: 'Compra producto',
            href: '/app/administracion/compraproducto',
            permission: [
              'app:general:administracion:compraproducto:view',
            ],
          },
          // {
          //   title: 'Detalle bonos',
          //   href: '/app/administracion/detallebonos',
          //   permission: [
          //     'app:administracion:liquidacionbonos:control',
          //   ],
          // },
          // {
          //   title: 'Liquidación bonos',
          //   href: '/app/administracion/liquidacionbonos',
          //   permission: [
          //     'app:administracion:liquidacionbonos:control',
          //   ],
          // },
          {
            title: 'Control información personal',
            href: '/app/administracion/controlinformacionpersonal',
            permission: [
              'app:general:administracion:controlinformacionpersonal:view',
            ],
          },
          // {
          //   title: 'Control perfiles',
          //   href: '/app/administracion/perfil/control',
          //   permission: [
          //     'app:administracion:perfil:control',
          //   ],
          // },
          // {
          //   title: 'Control publicaciones',
          //   href: '/app/administracion/publicaciones/control',
          //   permission: [
          //     'app:administracion:publicaciones:control',
          //   ],
          // },
          // {
          //   title: 'Control suscripciones',
          //   href: '/app/administracion/suscripciones/control',
          //   permission: [
          //     'app:administracion:suscripciones:control',
          //   ],
          // },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: 'Centro de ayuda',
        href: '/app/centrodeayuda',
        icon: HelpIcon,
        permission: [
          'app:general:centrodeayuda:preguntasfrecuentes:view',
         // 'app:general:centrodeayuda:enviarpreguntas:view',
          'app:general:centrodeayuda:sugerencias:view',
        ],
        items: [
          {
            title: 'Preguntas frecuentes',
            href: '/app/centrodeayuda/preguntasfrecuentes',
            permission: [
              'app:general:centrodeayuda:preguntasfrecuentes:view',
            ],
          },
          /*
          {
            title: 'Enviar preguntas',
            href: '/app/centrodeayuda/enviarpreguntas',
            permission: [
              'app:general:centrodeayuda:enviarpreguntas:view',
            ],
          },
          */
          {
            title: 'Sugerencias',
            href: '/app/centrodeayuda/sugerencias',
            permission: [
              'app:general:centrodeayuda:sugerencias:view',
            ],
          },
          /*
          {
            title: 'Agendar demostración',
            href: '/app/centrodeayuda/agendardemostracion',
            permission: [
              'app:centrodeayuda:agendarDemostraciones',
            ],
          },
          */
        ],
      },
    ],
  },
  {
    items: [
      {
        title: 'Configuración',
        href: '/app/configuracion',
        icon: SettingsIcon,
        permission: [
          'app:general:configuracion:catalogo:categoriaproductos:view',
          'app:general:configuracion:catalogo:productos:view',
          'app:general:configuracion:generales:metodosdepago:view',
          'app:general:configuracion:generales:bancos:view',
          'app:general:configuracion:generales:monedas:view',
          'app:general:configuracion:generales:terminosycondiciones:view',
          'app:general:configuracion:generales:tiposusuario:view',
          'app:general:configuracion:generales:parentesco:view',
          'app:general:configuracion:generales:divisionpolitica:paises:view',
          'app:general:configuracion:generales:divisionpolitica:departamentos:view',
          'app:general:configuracion:generales:divisionpolitica:ciudades:view',
          'app:general:configuracion:miperfil:criptomoneda:view',
          'app:general:configuracion:centrodeayuda:preguntasfrecuentes:view',
          'app:general:configuracion:centrodeayuda:ayudasgraficas:view',
          'app:general:configuracion:seguridad:usuarios:view',
          'app:general:configuracion:seguridad:cambiodecontraseña:view',
          'app:general:configuracion:seguridad:roles:view',
        ],
        items: [
          {
            title: 'Catálogo',
            href: '/app/configuracion/catalogo',
            permission: [
              'app:general:configuracion:catalogo:categoriaproductos:view',
              'app:general:configuracion:catalogo:productos:view',
            ],
            items: [
              {
                title: 'Categoría productos',
                href: '/app/configuracion/catalogo/categoriaproductos',
                permission: [
                  'app:general:configuracion:catalogo:categoriaproductos:view',
                ],
              },
              {
                title: 'Productos',
                href: '/app/configuracion/catalogo/productos',
                permission: [
                  'app:general:configuracion:catalogo:productos:view',
                ],
              },
            ],
          },
          {
            title: 'Generales',
            href: '/app/configuracion/generales',
            permission: [
              'app:general:configuracion:generales:metodosdepago:view',
              'app:general:configuracion:generales:bancos:view',
              'app:general:configuracion:generales:monedas:view',
              'app:general:configuracion:generales:terminosycondiciones:view',
              'app:general:configuracion:generales:tiposusuario:view',
              'app:general:configuracion:generales:parentesco:view',
            ],
            items: [
              {
                title: 'Métodos de pago',
                href: '/app/configuracion/generales/metodosdepago',
                permission: [
                  'app:general:configuracion:generales:metodosdepago:view',
                ],
              },
              {
                title: 'Bancos',
                href: '/app/configuracion/generales/bancos',
                permission: [
                  'app:general:configuracion:generales:bancos:view',
                ],
              },
              {
                title: 'Monedas',
                href: '/app/configuracion/generales/monedas',
                permission: [
                  'app:general:configuracion:generales:monedas:view',
                ],
              },
              {
                title: 'Términos y condiciones',
                href: '/app/configuracion/generales/terminosycondiciones',
                permission: [
                  'app:general:configuracion:generales:terminosycondiciones:view',
                ],
              },
              {
                title: 'Tipos usuario',
                href: '/app/configuracion/generales/tiposusuario',
                permission: [
                  'app:general:configuracion:generales:tiposusuario:view',
                ],
              },
              {
                title: 'Parentesco',
                href: '/app/configuracion/generales/parentesco',
                permission: [
                  'app:general:configuracion:generales:parentesco:view',
                ],
              },
              {
                title: 'División política',
                href: '/app/configuracion/generales/divisionPolitica',
                permission: [
                  'app:general:configuracion:generales:divisionpolitica:paises:view',
                  'app:general:configuracion:generales:divisionpolitica:departamentos:view',
                  'app:general:configuracion:generales:divisionpolitica:ciudades:view',
                ],
                items: [
                  {
                    title: 'Países',
                    href: '/app/configuracion/generales/divisionPolitica/paises',
                    permission: [
                      'app:general:configuracion:generales:divisionpolitica:paises:view',
                    ],
                  },
                  {
                    title: 'Departamentos',
                    href: '/app/configuracion/generales/divisionPolitica/departamentos',
                    permission: [
                      'app:general:configuracion:generales:divisionpolitica:departamentos:view',
                    ],
                  },
                  {
                    title: 'Ciudades',
                    href: '/app/configuracion/generales/divisionPolitica/ciudades',
                    permission: [
                      'app:general:configuracion:generales:divisionpolitica:ciudades:view',
                    ],
                  },
                ],
              },
            ],
          },
          /*
          {
            title: 'Mis compras',
            items: [
              // {
              //   title: 'Tipos suscripciones',
              //   href: '/app/configuracion/miscompras/tipossuscripciones',
              // },
            ],
          },
          */
          {
            title: 'Mi perfil',
            href: '/app/configuracion/miperfil',
            permission: [
              'app:general:configuracion:miperfil:criptomoneda:view',
            ],
            items: [
              // {
              //   title: 'Servicios',
              //   href: '/app/configuracion/miperfil/servicios',
              //   permission: [
              //     'app:configuracion:miperfil:servicios',
              //   ],
              // },
              // {
              //   title: 'Clasificación usuarios',
              //   href: '/app/configuracion/miperfil/clasificacionusuarios',
              //   permission: [
              //     'app:configuracion:miperfil:servicios',
              //   ],
              // },
              // {
              //   title: 'Identidades sexuales',
              //   href: '/app/configuracion/miperfil/identidadessexuales',
              //   permission: [
              //     'app:configuracion:miperfil:identidadessexuales',
              //   ],
              // },
              // {
              //   title: 'Orientaciones sexuales',
              //   href: '/app/configuracion/miperfil/orientacionessexuales',
              //   permission: [
              //     'app:configuracion:miperfil:orientacionessexuales',
              //   ],
              // },
              // {
              //   title: 'Tipos de oral',
              //   href: '/app/configuracion/miperfil/tiposdeoral',
              //   permission: [
              //     'app:configuracion:miperfil:tiposdeoral',
              //   ],
              // },
              // {
              //   title: 'Tipos de fantasías y fetiches',
              //   href: '/app/configuracion/miperfil/tiposdefantasiasyfetiches',
              //   permission: [
              //     'app:configuracion:miperfil:tiposdefantasiasyfetiches',
              //   ],
              // },
              // {
              //   title: 'Tipos de masajes',
              //   href: '/app/configuracion/miperfil/tiposdemasajes',
              //   permission: [
              //     'app:configuracion:miperfil:tiposdemasajes',
              //   ],
              // },
              // {
              //   title: 'Servicios virtuales',
              //   href: '/app/configuracion/miperfil/serviciosvirtuales',
              //   permission: [
              //     'app:configuracion:miperfil:serviciosvirtuales',
              //   ],
              // },
              // {
              //   title: 'Ojos',
              //   href: '/app/configuracion/miperfil/ojos',
              //   permission: [
              //     'app:configuracion:miperfil:ojos',
              //   ],
              // },
              // {
              //   title: 'Cabello',
              //   href: '/app/configuracion/miperfil/cabello',
              //   permission: [
              //     'app:configuracion:miperfil:cabello',
              //   ],
              // },
              // {
              //   title: 'Cuerpo',
              //   href: '/app/configuracion/miperfil/cuerpo',
              //   permission: [
              //     'app:configuracion:miperfil:cuerpo',
              //   ],
              // },
              // {
              //   title: 'Piel',
              //   href: '/app/configuracion/miperfil/piel',
              //   permission: [
              //     'app:configuracion:miperfil:piel',
              //   ],
              // },
              // {
              //   title: 'Busto',
              //   href: '/app/configuracion/miperfil/busto',
              //   permission: [
              //     'app:configuracion:miperfil:busto',
              //   ],
              // },
              // {
              //   title: 'Cola',
              //   href: '/app/configuracion/miperfil/cola',
              //   permission: [
              //     'app:configuracion:miperfil:cola',
              //   ],
              // },
              // {
              //   title: 'Polla',
              //   href: '/app/configuracion/miperfil/polla',
              //   permission: [
              //     'app:configuracion:miperfil:polla',
              //   ],
              // },
              // {
              //   title: 'Idioma',
              //   href: '/app/configuracion/miperfil/idioma',
              //   permission: [
              //     'app:configuracion:miperfil:idioma',
              //   ],
              // },
              // {
              //   title: 'Depilación',
              //   href: '/app/configuracion/miperfil/depilacion',
              //   permission: [
              //     'app:configuracion:miperfil:depilacion',
              //   ],
              // },
              // {
              //   title: 'Etnia',
              //   href: '/app/configuracion/miperfil/etnia',
              //   permission: [
              //     'app:configuracion:miperfil:etnia',
              //   ],
              // },
              {
                title: 'Criptomoneda',
                href: '/app/configuracion/miperfil/criptomoneda',
                permission: [
                  'app:general:configuracion:miperfil:criptomoneda:view',
                ],
              },
              /*
              {
                title: 'Red',
                href: '/app/configuracion/miperfil/red',
                permission: [
                  'app:configuracion:miperfil:red',
                ],
              },
              */
            ],
          },
          /*
          {
            title: 'Mis compras',
            href: '/app/configuracion/miscompras',
            items: [
              {
                title: 'Tipos suscripción',
                href: '/app/configuracion/miscompras/tipossuscripcion',
                // Falta por permisos
              },
            ],
          },
          */
          {
            title: 'Centro de ayuda',
            href: '/app/configuracion/centrodeayuda',
            permission: [
              'app:general:configuracion:centrodeayuda:preguntasfrecuentes:view',
              'app:general:configuracion:centrodeayuda:ayudasgraficas:view',
            ],
            items: [
              {
                title: 'Preguntas frecuentes',
                href: '/app/configuracion/centrodeayuda/preguntasfrecuentes',
                permission: [
                  'app:general:configuracion:centrodeayuda:preguntasfrecuentes:view',
                ],
              },
              {
                title: 'Ayudas gráficas',
                href: '/app/configuracion/centrodeayuda/ayudasgraficas',
                permission: [
                  'app:general:configuracion:centrodeayuda:ayudasgraficas:view',
                ],
              },
            ],
          },
          {
            title: 'Seguridad',
            href: '/app/configuracion/seguridad',
            permission: [
              'app:general:configuracion:seguridad:usuarios:view',
              'app:general:configuracion:seguridad:cambiodecontraseña:view',
              'app:general:configuracion:seguridad:roles:view',
            ],
            items: [
              {
                title: 'Usuarios',
                href: '/app/configuracion/seguridad/usuarios',
                permission: [
                  'app:general:configuracion:seguridad:usuarios:view',
                ],
              },
              {
                title: 'Cambio de contraseña',
                href: '/app/configuracion/seguridad/cambiodecontrasena',
                permission: [
                  'app:general:configuracion:seguridad:cambiodecontraseña:view',
                ],
              },
              {
                title: 'Roles',
                href: '/app/configuracion/seguridad/roles',
                permission: [
                  'app:general:configuracion:seguridad:roles:view',
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export default navConfig;
